module.exports = __webpack_public_path__ + "static/img/noticia5.7b35ec55.jpeg";